import React from 'react'
import { useDataLayer } from '../../hooks/useDataLayer'
import { useToolOverlay } from '../Context/ToolOverlayContext'
import EditIcon from '../icons/EditIcon'

const FooterPlanungstools = ({ heading, body }) => {
  const dataLayer = useDataLayer()
  const { setToolOverlayOpen, setContextSectionLimit } = useToolOverlay()

  return (
    <div className="pl-2 md:pl-0">
      <EditIcon className="w-4.5 h-auto mb-2" />
      <div className="mb-3">
        <button
          type="button"
          className="text-[15px] font-bold leading-normal underline transition-colors hover:text-red-as"
          onClick={() => {
            setContextSectionLimit('planningtool')
            setToolOverlayOpen(true)
            dataLayer.push({
              event: 'userinteraction',
              eventCategory: 'Navigation',
              eventAction: 'click',
              eventLabel: heading,
              event_location: 'footer',
            })
          }}
        >
          {heading}
        </button>
      </div>
      <div
        className="u-p-small mb-11 lg:mb-0 link-wrapper"
        dangerouslySetInnerHTML={{ __html: body }}
      />
    </div>
  )
}

export default FooterPlanungstools
